import React, { useContext, useEffect, useRef, useState } from 'react';
import { CircularProgress, FormHelperText, Grid, IconButton, LinearProgress, Tooltip } from '@material-ui/core';
import { ArrowLeft, ArrowRight, Close, Image, Mail, Visibility, Backup } from '@material-ui/icons';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import { getWorkflowData } from '../../../../Core/Service/workflowData-service';
import './documentModal.scss';
import {
    getDocumentByName,
    getDocumentVideoByName,
    getOcrDocumentHistoryForJob,
    getWorkflowStepsOCRDoc_List,
    uploadOcrDoc
} from '../../../../Core/Service/workflowJobDocument-service';
import doc from '../../../internal/workflow-job/doc.png';
import { SecondaryButton, SingelSelect } from '../../../../Core/FormInput';
import moment from 'moment';
import DownloadDocModal from '../../../internal/workflow-job/more/DownloadDoc';
import { useWindowSize } from '../../../../Core/Controls/ScreenResolution';
import { AppStorage } from '../../../../Core/Service/storage-service';
import MailDocModal from '../../../internal/workflow-job/more/MailDoc';
import AppContext from '../../../../App/AppContext';

const DocTableRow = ({ item, showDocument, mailDocument, downloadDocument, currentVisibleDocumentName, isDocumentLoading, isHide }) => {
    return (
        <tr className="row">
            <td>{item.ocrDocName}</td>
            {isHide && <td className="time-type">{new Date(item.createdAt).toLocaleString()}</td>}
            <td className="actions">
                <div className="icon-button-group">
                    {/* <Tooltip title="View"> */}
                    <IconButton
                        title={'View'}
                        color={currentVisibleDocumentName === item.docName ? 'primary' : 'secondary'}
                        onClick={() => showDocument(item)}
                        disabled={isDocumentLoading}
                    >
                        {isDocumentLoading && currentVisibleDocumentName === item.docName ? <CircularProgress size={20} /> : <Visibility />}
                    </IconButton>
                    {/* </Tooltip> */}
                    <Tooltip title="Mail Document">
                        <IconButton color="secondary" onClick={() => mailDocument(item)}>
                            <Mail />
                        </IconButton>
                    </Tooltip>
                    {/* <Tooltip title="Download Document"> */}

                    <IconButton title={'Download Document'} color="secondary" onClick={() => downloadDocument(item)}>
                        <AssignmentReturnedIcon />
                    </IconButton>
                    {/* </Tooltip> */}
                </div>
            </td>
        </tr>
    );
};

const DocTable = ({ documents, showDocument, mailDocument, downloadDocument, currentVisibleDocumentName, isDocumentLoading }) => {
    let hideDocCreatedValue = AppStorage.getCanHideDocumentCreation();
    return (
        <div className="body-table-container custom-scroll">
            <table className="all-documents-body">
                <thead>
                    <tr className="header">
                        <th>Document</th>
                        {!hideDocCreatedValue && <th className="created-by">Created By</th>}
                        <th className="actions">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {documents.length > 0 ? (
                        <>
                            {documents.map((document, index) => (
                                <DocTableRow
                                    key={index}
                                    item={document}
                                    showDocument={showDocument}
                                    mailDocument={mailDocument}
                                    downloadDocument={downloadDocument}
                                    currentVisibleDocumentName={currentVisibleDocumentName}
                                    isDocumentLoading={isDocumentLoading}
                                    isHide={!hideDocCreatedValue}
                                />
                            ))}
                        </>
                    ) : (
                        <tr>
                            <td colspan={'3'}>No Documents Available</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

const DocumentListComponent = (props) => {
    const { showToast } = useContext(AppContext);
    let hideDocCreatedValue = AppStorage.getCanHideDocumentCreation();

    const [widths] = useWindowSize();
    const tabView = widths < 1260 ? true : false;

    const [jobDetails, setJobDetails] = useState({ documents: [] });
    const [currentPageNo, setPageNo] = useState(0);

    const [screenState, setScreenState] = useState({
        allFilled: false,
        isReadonly: true,
        showNotesModal: false,
        showHistoryModal: false,
        showReturnReasonModal: false,
        showOcrDocHistory: false,
        documentRotateBy: 0,
        zoomFactor: 1,
        showMailModal: false,
        docInfoToMail: undefined,
        showAllDocModal: false,
        showWarning: false,
        showReturnReasonHistoryModal: false,
        showBarCode: false,
        showCustomerNotes: false,
        showHeaderDetails: false
    });
    const [state, setState] = useState({
        isSelectedFilePdf: false,
        imagesFromUrl: [],
        selectedDocHistory: [],
        currentVisibleDocName: null,
        loadingDoc: false,
        tabView: tabView,
        stepsOCRDocList: []
    });
    const docContainer = useRef(null);

    // const rotateDoc = (explicit = undefined) => {
    //     if (explicit === undefined) {
    //         setScreenState((st) => ({
    //             ...st,
    //             documentRotateBy: (st.documentRotateBy + 90) % 360
    //         }));
    //     } else {
    //         setScreenState((st) => ({
    //             ...st,
    //             documentRotateBy: explicit
    //         }));
    //     }
    // };

    const getDocumentHistory = (jobId, ocrDocId) => {
        return getOcrDocumentHistoryForJob(jobId, ocrDocId);
    };

    const pullDocumentVideoByName = (docName) => {
        return getDocumentVideoByName(docName);
    };

    const addDocumentImagesData = (ocrDocId, docName, imgBase64Src) => {
        setState((st) => {
            const imagesFromUrl = [...st.imagesFromUrl];
            imagesFromUrl.push(imgBase64Src);
            return {
                ...st,
                selectedOcrDocId: ocrDocId,
                selectedOcrDocName: docName,
                imagesFromUrl
            };
        });
    };

    const pullDocument_V1 = async (docId, name, pageNo = 1) => {
        return getDocumentByName(name, pageNo).then((res) => {
            addDocumentImagesData(docId, name, res.imgBase64Src);
            return res.hasMorePage && pullDocument_V1(docId, name, pageNo + 1);
        });
    };

    const loadDocument = async (docId, docName, fromSteps, OcrDoc, isVideo) => {
        if (isVideo) {
            setState((st) => ({ ...st, docHistoryLoading: true, loadingDoc: true }));
            getDocumentHistory(props.headerRecordID, docId).then((res) => {
                if (res.success) {
                    let rec = res.data;
                    setState((st) => ({ ...st, selectedOcrDocHistoryCount: rec.length, selectedDocHistory: rec, imagesFromUrl: [], videoFromUrl: null }));
                }
            });
            pullDocumentVideoByName(docName).then((res) => {
                let rec = res;
                const url = window.URL.createObjectURL(new Blob([rec.data]));
                setState((st) => ({
                    ...st,
                    loadingDoc: false,
                    isSelectedFilePdf: false,
                    selectedOcrDocName: docName,
                    docHistoryLoading: false,
                    videoFromUrl: url,
                    currentVisibleDocName: docName,
                    selectedOcrDocId: docId
                }));
            });
        } else {
            // !props.canUseNewStamp && setLoadedStamps([]);
            setState((st) => ({ ...st, docHistoryLoading: true }));
            // setPageNo(0);
            getDocumentHistory(props.headerRecordID, docId).then((res) => {
                if (res.success) {
                    let rec = res.data;
                    setState((st) => ({ ...st, selectedOcrDocHistoryCount: rec.length, selectedDocHistory: rec }));
                }
            });

            const isPdf = docName.toLowerCase().trim().endsWith('.pdf');
            setState((st) => ({
                ...st,
                loadingDoc: true,
                isSelectedFilePdf: isPdf,
                imagesFromUrl: [],
                videoFromUrl: null,
                currentVisibleDocName: docName,
                selectedOcrDocId: docId
            }));

            pullDocument_V1(docId, docName).finally(() => {
                setState((st) => ({ ...st, loadingDoc: false, docHistoryLoading: false }));
            });
        }
    };

    const downloadDocument = async (docId, docName, fromSteps = false, OcrDoc = false, isVideo = false) => {
        if (docName) {
            if (state.selectedOcrDocId !== docId || state.selectedOcrDocName !== docName) {
                loadDocument(docId, docName, fromSteps, OcrDoc, isVideo);
            }
        } else {
            setState((st) => ({ ...st, isSelectedFilePdf: false, imagesFromUrl: [] }));
        }
    };

    const showAlldocState = (item) => {
        setState((st) => ({ ...st, tabView: false }));
        console.log(item.ocrDocId, item.docName, item.IsVideo, 'showdoc, id, IsVideo');
        downloadDocument(item.ocrDocId, item.docName, item.IsVideo);
    };

    const displayDoc = () => {
        let content = null;
        const width = docContainer?.current?.clientWidth;
        const scaledWidth = parseInt(width) * screenState.zoomFactor;
        const styleObj = {};

        if (state.videoFromUrl) {
            if (screenState.documentRotateBy === 0 || screenState.documentRotateBy === 180) {
                styleObj.width = `calc(${scaledWidth}px - 6px)`;
            } else {
                styleObj.height = `calc(${scaledWidth}px - 6px)`;
            }
            content = (
                <video controls controlsList="nodownload" style={styleObj}>
                    <source src={state.videoFromUrl} type="video/mp4" />
                </video>
            );
        } else if (state.imagesFromUrl.length === 0) {
            content = <img src={doc} alt="No document selected" className="sample-doc" />;
        } else {
            const imgClassName = `shown-doc deg-${screenState.documentRotateBy}`;
            // if (props.canUseNewStamp) {
            content = <img alt="Document's" src={state.imagesFromUrl[currentPageNo]} className={imgClassName} />;
            // } else {
            //     if (screenState.documentRotateBy === 0 || screenState.documentRotateBy === 180) {
            //         styleObj.width = `calc(${scaledWidth}px - 6px)`;
            //     } else {
            //         styleObj.height = `calc(${scaledWidth}px - 6px)`;
            //     }
            //     content = state.imagesFromUrl.map((imgBase64, i) => <img key={i} alt="Document's" src={imgBase64} className={imgClassName} style={styleObj} />);
            // }
        }

        return content;
    };

    const fetchWorkflowData = async () => {
        const response = await getWorkflowData(props.headerRecordID);
        setJobDetails((st) => ({ ...st, documents: response.data.documents, jobBasicDetail: response.data.jobBasicDetail }));
        // setDocuments(response.data.documents);
    };
    useEffect(() => {
        fetchWorkflowData();
    }, [props.headerRecordID]);

    const showDownload = (item) => {
        setScreenState((st) => ({
            ...st,
            showDownloadModal: true,
            docInfoToMail: {
                ocrDocName: item.docName,
                ocrDocId: item.ocrDocId,
                // SendAllVersions: isMultiVersion,
                headerId: props.headerRecordID,
                docName: `${item.ocrDocName}`,
                createdAt: moment(item.createdAt).format('DD-MMM-YYYY HH:mm')
            }
        }));
    };

    const hideDownload = () => {
        setScreenState((st) => ({
            ...st,
            showDownloadModal: false,
            docInfoToMail: undefined
        }));
    };

    const hideMail = () => {
        setScreenState((st) => ({
            ...st,
            showMailModal: false,
            docInfoToMail: undefined
        }));
    };

    const showMail = (item) => {
        setScreenState((st) => ({
            ...st,
            showMailModal: true,
            docInfoToMail: {
                ocrDocumentName: item.ocrDocName,
                docName: item.docName,
                ocrDocIdToMail: item.ocrDocId
            }
        }));
    };

    const hasPrev = (pageNo) => {
        return pageNo > 0;
    };

    const hasNext = (pageNo) => {
        let total = state.imagesFromUrl.length;
        return pageNo < total - 1;
    };

    const showStep = state.tabView || widths > 1260;
    const showDoc = !state.tabView || widths > 1260;

    console.log(state.tabView, 'state.tabView');
    console.log(showDoc, 'showDoc');

    useEffect(async () => {
        let res = await getWorkflowStepsOCRDoc_List();
        setState((st) => ({ ...st, stepsOCRDocList: res.data.list || [] }));
    }, [props.jobId]);

    const singleSelectChange = (nm) => (ev, vl) => {
        setState((st) => {
            let newSt = {
                ...st,
                [nm]: vl
            };
            return newSt;
        });
    };

    const [uploading, setUploading] = useState(false);

    const uploadDoc = async (e) => {
        const formData = new FormData();
        for (let i = 0; i < e.target.files.length; i++) {
            formData.append(e.target.files[i].name, e.target.files[i]);
        }

        setUploading(true);
        let res = await uploadOcrDoc(props.headerRecordID, state.selectStepDoc.id, formData);

        fetchWorkflowData();
        setUploading(false);
        if (res.success) {
            showToast('File Uploaded successfully.');
        }
    };

    return (
        <Grid container className="all-documents" alignItems="flex-start" justifyContent="center">
            {showStep && (
                <Grid item xs={12} lg={hideDocCreatedValue ? 3 : 4} xl={hideDocCreatedValue ? 2 : 3}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs>
                                    {/* <InputLabel required shrink>
                                        Editable in Workflow
                                    </InputLabel> */}
                                    <SingelSelect
                                        options={state.stepsOCRDocList || []}
                                        value={state.selectStepDoc}
                                        onChange={singleSelectChange('selectStepDoc')}
                                    />
                                    <FormHelperText error>{state.selectStepDocError}</FormHelperText>
                                </Grid>
                                <Grid item>
                                    <Tooltip title="Upload Document">
                                        <label>
                                            <IconButton color="secondary" component="span" disabled={!state.selectStepDoc}>
                                                <Backup />
                                                <input
                                                    disabled={!state.selectStepDoc}
                                                    type="file"
                                                    onChange={uploadDoc}
                                                    // className="upload-btn-input-file"
                                                    style={{ display: 'none' }}
                                                    accept="video/mp4,video/x-m4v,video/*,image/*,application/pdf"
                                                    // accept="image/*,application/pdf"
                                                    multiple
                                                />
                                                {uploading && <CircularProgress size={20} className="upload-progress" color="secondary" />}
                                            </IconButton>
                                        </label>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <DocTable
                                documents={jobDetails.documents}
                                showDocument={showAlldocState}
                                mailDocument={showMail}
                                downloadDocument={showDownload}
                                currentVisibleDocumentName={state.currentVisibleDocName}
                                isDocumentLoading={state.loadingDoc}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            )}
            {showDoc && (
                <Grid
                    item
                    xs={12}
                    lg={hideDocCreatedValue ? 9 : 8}
                    xl={hideDocCreatedValue ? 10 : 9}
                    className="right-doc-sec"
                    style={{ borderLeft: '1px solid black', textAlign: 'center' }}
                >
                    {!showStep && (
                        <div className="document-close-action">
                            <Tooltip title="Close">
                                <IconButton
                                    component="span"
                                    onClick={() => {
                                        setState((st) => ({ ...st, tabView: true }));
                                    }}
                                >
                                    <Close />
                                </IconButton>
                            </Tooltip>
                        </div>
                    )}
                    {hasPrev(currentPageNo) && (
                        <div className="doc-page-move go-prev">
                            <IconButton component="span" color="default" onClick={() => setPageNo(currentPageNo - 1)}>
                                <ArrowLeft />
                            </IconButton>
                        </div>
                    )}
                    {hasNext(currentPageNo) && (
                        <div className="doc-page-move go-next">
                            <IconButton component="span" color="default" onClick={() => setPageNo(currentPageNo + 1)}>
                                <ArrowRight />
                            </IconButton>
                        </div>
                    )}

                    <div
                        className={`document-viewer custom-scroll${state.isSelectedFilePdf && state.imagesFromUrl.length ? ' multi-image-from-pdf' : ''}`}
                        style={{ height: `calc(100vh - 120px)`, marginLeft: '5px' }}
                        ref={docContainer}
                    >
                        {state.loadingDoc ? <LinearProgress /> : null}
                        {displayDoc()}
                    </div>
                    <div className="actionButton-Container" style={{ marginBottom: 5, marginLeft: '5px' }}>
                        <Grid container spacing={1}>
                            {state.docHistoryLoading ? (
                                <>Loading...</>
                            ) : (
                                state.selectedDocHistory.map((m) => {
                                    return (
                                        <Grid item>
                                            <SecondaryButton
                                                className="historydoclist"
                                                title={moment(m.createdAt).format('LLL')}
                                                variant={m.docName == state.selectedOcrDocName ? 'contained' : 'outlined'}
                                                onClick={() => downloadDocument(state.selectedOcrDocId, m.docName, false, false, m.isVideo)}
                                            >
                                                <Image />
                                            </SecondaryButton>
                                        </Grid>
                                    );
                                })
                            )}
                        </Grid>
                    </div>
                </Grid>
            )}
            {screenState.showDownloadModal && (
                <DownloadDocModal
                    jobId={props.headerRecordID}
                    onClose={hideDownload}
                    docInfoToMail={screenState.docInfoToMail}
                    jobBasicDetail={jobDetails.jobBasicDetail}
                />
            )}
            {screenState.showMailModal && (
                <MailDocModal
                    jobId={props.headerRecordID}
                    onClose={hideMail}
                    docInfoToMail={screenState.docInfoToMail}
                    jobBasicDetail={jobDetails.jobBasicDetail}
                    // showToast={showToast}
                />
            )}
        </Grid>
    );
};

export default DocumentListComponent;
